export const socialLinks = {
  email: 'mailto:dower.julian@gmail.com',
  github: 'https://github.com/juliandower',
  soundcloud: 'https://soundcloud.com/yungjuan420',
};

export const featuredProject = {
  title: 'wissenwert',
  description:
    'A finance quiz that turns your confidence into risk. Test your knowledge with leverage and hedge mechanics.',
  href: 'https://wissenwert.juliandower.com',
  linkLabel: 'Play wissenwert',
  meta: [
    { label: 'Format', value: 'Interactive quiz' },
    { label: 'Focus', value: 'Learning through risk' },
    { label: 'Status', value: 'Live' },
  ],
};

export const wispAnchorProject = {
  title: 'wisp-anchor',
  description:
    'A voice-first thinking tool that turns unstructured thoughts into an explorable mind map.',
  href: 'https://wisp-anchor.juliandower.com',
  linkLabel: 'Open wisp-anchor',
  meta: [
    { label: 'Format', value: 'Voice-to-map tool' },
    { label: 'Focus', value: 'Thinking out loud' },
    { label: 'Status', value: 'Live' },
  ],
};

export const experiments = [
  {
    title: 'Sound sketches',
    description: 'Music production, loops and works in progress.',
  },
  {
    title: 'Small interfaces',
    description: 'Compact tools, game mechanics and interactions.',
  },
  {
    title: 'Learning systems',
    description: 'Experiments in language, finance and visual thinking.',
  },
];
